import React from "react";
import { Field } from "react-final-form";
import { TextInput } from "../../../components/inputs/final_form/TextInput";
import { LoadingButton } from "../../../components/LoadingButton";
import { required } from "../../../util/validators";

export const PayorNoteForm = ({ handleSubmit, submitting }) => {
  return (
    <>
      <Field component={TextInput} type="textarea" required validate={required} label="Note" name="note" />

      <LoadingButton loading={submitting} onClick={handleSubmit} disabled={submitting}>
        Submit
      </LoadingButton>
    </>
  );
};
